import { useState } from 'react';

interface SafeImageProps {
  readonly src: string;
  readonly alt: string;
  readonly className: string;
}

export function SafeImage({ src, alt, className }: SafeImageProps) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);

  if (failedSrc === src) {
    return <span className={`${className} vp-image-fallback`} aria-hidden="true" />;
  }

  return <img src={src} alt={alt} className={className} onError={() => setFailedSrc(src)} />;
}
